const DefaultSvgDefs = () => {
  return null;
};
export {
  DefaultSvgDefs
};
//# sourceMappingURL=DefaultSvgDefs.mjs.map
